import { ExtraErrorData } from '@sentry/integrations';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { get } from 'lodash';
import history from './src/router/history';
import { SENTRY_DSN } from './src/tools/constant';
import {
  getLanguage,
  getUserName,
  getUserToken,
} from './src/tools/getUserInfo';
import { isObject, isString } from './src/tools/helper';
const errCodes = [400, 401, 403, 404, 406, 500];

const localEnv = 'local-development';
const test2Env = 'test2-development';
const preEnv = 'preprod-env';
const prodEnv = 'prod-env';
const test2Arm = 'test2-arm-development';
const envDict = {
  test2: test2Env,
  local: localEnv,
  pre: preEnv,
  prod: prodEnv,
  'test2-arm': test2Arm,
};

const env = process.env.REACT_ENV;
const __useRequestError = 'useRequest has caught the exception';
const __cancelRequest = 'cancel Cancel';

const iniSentry = () => {
  const local = process.env.local;
  const isLocal = local == '1';

  if (!isLocal) {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: envDict[env],
      integrations: [
        new BrowserTracing({
          routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
        }),
        new ExtraErrorData(),
      ],
      ignoreErrors: ['Request is cancelled'],

      // We recommend adjusting this value in production, or using tracesSampler
      // for finer control
      tracesSampleRate: 0,
      beforeSend: handleOnBeforeSend,
    });
    const name = getUserName();
    const token = getUserToken();
    const lang = getLanguage();
    Sentry.setUser({ name, t: token, lang });
  }
};
export { iniSentry };

const handleOnBeforeSend = (event, hint) => {
  if (envDict[env] !== 'prod-env') {
    return null;
  }
  const label = __beforeSending(event, hint, [
    onGetUseRequest,
    onGetNormalRequest,
    onCancelRequest,
  ]);
  return label;
};

function __beforeSending(event, hint, check) {
  if (check.length >= 1) {
    const fun = check.pop();
    const label = fun(event, hint);

    if (label) {
      return __beforeSending(event, hint, check);
    } else {
      return null;
    }
  } else {
    return event;
  }
}

const onGetUseRequest = (event, hint) => {
  const error = hint.originalException;
  if (isString(error)) {
    if (error.startsWith(__useRequestError)) {
      return 0;
    }
  }
  return event;
};
const onGetNormalRequest = (event, hint) => {
  const error = hint.originalException;
  if (isObject(error)) {
    const code = get(error, 'code');
    if (errCodes.includes(code)) {
      return 0;
    }
  }
  return event;
};
const onCancelRequest = (event, hint) => {
  const error = get(hint, 'originalException.message');
  if (isString(error)) {
    if (error.startsWith(__cancelRequest)) {
      return 0;
    }
  }
  return event;
};
